<template>
  <div class="svg-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 535.18 522.91"
      class="h-full"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
      v-if="count === 1"
    >
      <path
        d="M216.6,368A20.92,20.92,0,0,1,185,371.51L85.47,278.18a20.93,20.93,0,0,0-29.67,1L14.05,324.28a20.93,20.93,0,0,0,1,29.49L206.94,533.5a20.92,20.92,0,0,0,31.6-3.49L540,87.31a20.92,20.92,0,0,0-5.43-29L478.83,19.93a21,21,0,0,0-29.17,5.47L216.6,368Z"
        transform="translate(-8.47 -16.25)"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 729.1 522.91"
      class="w-full h-full"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
      v-if="count === 2"
    >
      <path
        class="cls-1"
        d="M932.85,87.31,631.37,530a20.93,20.93,0,0,1-31.61,3.49c-22.17-20.77-61.83-57.92-100.54-94.2l-80.75-75.64,58.77-86.39c.36.28.71.59,1.05.91L558,353l19.78,18.55A20.92,20.92,0,0,0,609.43,368L842.49,25.41a20.94,20.94,0,0,1,29.17-5.48l55.76,38.36A20.92,20.92,0,0,1,932.85,87.31Z"
        transform="translate(-207.39 -16.25)"
      />
      <path
        class="cls-1"
        d="M738.94,87.31,558,353,499.22,439.3,437.45,530a20.92,20.92,0,0,1-31.6,3.49L214,353.78a20.94,20.94,0,0,1-1-29.5l41.75-45.06a20.93,20.93,0,0,1,29.67-1l99.52,93.33A20.91,20.91,0,0,0,415.51,368l3-4.36,58.77-86.39L648.58,25.41a20.93,20.93,0,0,1,29.16-5.48L733.5,58.29A20.93,20.93,0,0,1,738.94,87.31Z"
        transform="translate(-207.39 -16.25)"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 923.45 522.91"
      class="w-full h-full"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
      v-if="count >= 3"
    >
      <path
        class="cls-1"
        d="M932.85,87.31,631.37,530a20.93,20.93,0,0,1-31.61,3.49c-22.17-20.77-61.83-57.92-100.54-94.2l-80.75-75.64,58.77-86.39c.36.28.71.59,1.05.91L558,353l19.78,18.55A20.92,20.92,0,0,0,609.43,368L842.49,25.41a20.94,20.94,0,0,1,29.17-5.48l55.76,38.36A20.92,20.92,0,0,1,932.85,87.31Z"
        transform="translate(-13.04 -16.25)"
      />
      <path
        class="cls-1"
        d="M738.94,87.31,558,353,499.22,439.3,437.45,530a20.92,20.92,0,0,1-31.6,3.49l-100.8-94.44L224.3,363.42,283.06,277q.68.54,1.32,1.14l79.48,74.53,20,18.8A20.91,20.91,0,0,0,415.51,368l3-4.36,58.77-86.39L648.58,25.41a20.93,20.93,0,0,1,29.16-5.48L733.5,58.29A20.93,20.93,0,0,1,738.94,87.31Z"
        transform="translate(-13.04 -16.25)"
      />
      <path
        class="cls-1"
        d="M544.59,87.31,363.86,352.71l-58.81,86.35L243.11,530a20.93,20.93,0,0,1-31.61,3.49L19.66,353.78a20.93,20.93,0,0,1-1-29.5l41.75-45.06a20.92,20.92,0,0,1,29.66-1l99.52,93.33A20.93,20.93,0,0,0,221.17,368l3.13-4.6L283.06,277,454.23,25.41a20.93,20.93,0,0,1,29.16-5.48l55.76,38.36A20.93,20.93,0,0,1,544.59,87.31Z"
        transform="translate(-13.04 -16.25)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "IconTick",
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
};
</script>
